import React, { useState, useEffect, useRef } from 'react'

import { Link} from 'react-router-dom'
import './Footer.css'
import { useGSAP } from "@gsap/react";
import gsap from "gsap";

import L from '../assets/Logo.svg'
import LogoLeft from '../assets/TopLogoLeft.png'
import LogoRight from '../assets/TopLogoRight.png'
import Chevron from '../assets/Chevron Down.svg'
import Chevron2 from '../assets/Chevron Right.svg'


import { useTranslation } from 'react-i18next'

const Footer = () => {
    
  const { t } = useTranslation();
    const [deviceWidth, setDeviceWidth] = useState(window.screen.width);
    const [isExpanded, setIsExpanded] = useState(false);
    const toggleExpansion = () => {
        setIsExpanded(prevState => !prevState);
      };
      const [isExpanded1, setIsExpanded1] = useState(false);
    
      const toggleExpansion1 = () => {
        setIsExpanded1(prevState => !prevState);
      };
      const [isExpanded2, setIsExpanded2] = useState(false);
    
      const toggleExpansion2 = () => {
        setIsExpanded2(prevState => !prevState);
      };
      const [isExpanded3, setIsExpanded3] = useState(false);
    
      const toggleExpansion3 = () => {
        setIsExpanded3(prevState => !prevState);
      };
    useEffect(() => {
      const handleResize = () => {
        setDeviceWidth(window.screen.width);
      };
      window.addEventListener('resize', handleResize);
      window.addEventListener('orientationchange', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
        window.removeEventListener('orientationchange', handleResize);
      };
    }, []);


    //hover underline
    const textRef = useRef(null); // Ref for the text container
    const underlineRef = useRef(null); // Ref for the underline element
    const containerRef = useRef(null);
  
    useGSAP(() => {
      if (containerRef.current) {
          const textElements = containerRef.current.querySelectorAll('.Footer-content-right-element-column-element');
  
          textElements.forEach((textElement) => {
              const underline = textElement.querySelector('span');
              // Ensure the underline is initially hidden
              gsap.set(underline, { scaleX: 0, transformOrigin: "left" });
  
              // Timeline for hover enter
              const tlEnter = gsap.timeline({ paused: true })
                  .to(underline, {
                      scaleX: 1,
                      transformOrigin: "left",
                      duration: 0.5,
                      ease: "power2.inOut"
                  });
  
              // Timeline for hover leave
              const tlLeave = gsap.timeline({ paused: true })
                  .to(underline, {
                      scaleX: 0,
                      transformOrigin: "right",
                      duration: 0.5,
                      ease: "power2.inOut"
                  });
  
              // Function to handle mouse enter
              function mouseEnterHandler() {
                  if (tlLeave.isActive()) {
                      tlLeave.pause();  // Ensure to pause leave timeline if it's active
                  }
                  tlEnter.restart();
              };
  
              // Function to handle mouse leave
              function mouseLeaveHandler() {
                  if (tlEnter.isActive()) {
                      tlEnter.pause();  // Ensure to pause enter timeline if it's active
                  }
                  tlLeave.restart();
              };
  
              textElement.addEventListener('mouseenter', mouseEnterHandler);
              textElement.addEventListener('mouseleave', mouseLeaveHandler);
  
              // Cleanup function needs to be able to access these handlers
              return () => {
                  textElement.removeEventListener('mouseenter', mouseEnterHandler);
                  textElement.removeEventListener('mouseleave', mouseLeaveHandler);
                  tlEnter.kill();
                  tlLeave.kill();
              };
          });
      }
  }, []);
  

  return (
    <div className="Footer">{deviceWidth>1023 &&
        <div className="Footer-content">
            <div className="Footer-content-left">
                <Link to='/'>
                <img loading="lazy" decoding="async" alt="Khamsa Insurance and Reinsurance Brokers" src={L} className="Footer-content-left-logo"/></Link>
                {/*<div className="Footer-content-left-logo">
                    <img loading="lazy" decoding="async" alt="" src={LogoLeft} className="Footer-content-left-logo1"/>
                    <img loading="lazy" decoding="async" alt="" src={LogoRight} className="Footer-content-left-logo2"/>
                </div>*/}
                <p className="Footer-content-left-bottom">{t('Address')}</p>
            </div>
            <div className="Footer-content-right" ref={containerRef}>
                <div className="Footer-content-right-element">
                    <p className="Footer-content-right-element-header">{t('TopBar1')}</p>
                    <div className="Footer-content-right-element-column">
                        <Link to="/who-we-are#aboutUs">
                        <p className="Footer-content-right-element-column-element">{t('TopBar11')} <span ref={underlineRef} style={{
                marginTop: '1px',
                height: '1px',
                backgroundColor: 'black',
                display: 'block',
                width: '100%', // Full width but scaleX will control the animation
                transform: 'scaleX(0)' // Start with underline hidden
            }} /></p></Link>
                        <Link to="/who-we-are#mv">  <p className="Footer-content-right-element-column-element">{t('TopBar12')} <span ref={underlineRef} style={{
                marginTop: '1px',
                height: '1px',
                backgroundColor: 'black',
                display: 'block',
                width: '100%', // Full width but scaleX will control the animation
                transform: 'scaleX(0)' // Start with underline hidden
            }} /></p></Link>
                        <Link to="/who-we-are#aze"> <p className="Footer-content-right-element-column-element">{t('TopBar13')}  <span ref={underlineRef} style={{
                marginTop: '1px',
                height: '1px',
                backgroundColor: 'black',
                display: 'block',
                width: '100%', // Full width but scaleX will control the animation
                transform: 'scaleX(0)' // Start with underline hidden
            }} /></p></Link>
                    </div>
                </div>
                <div className="Footer-content-right-element">
                    <p className="Footer-content-right-element-header">{t('TopBar2')}</p>
                    <div className="Footer-content-right-element-column">
                        <Link to="/what-we-offer" state={{ re: false }}>
                        <p className="Footer-content-right-element-column-element">{t('TopBar21')}  <span ref={underlineRef} style={{
                marginTop: '1px',
                height: '1px',
                backgroundColor: 'black',
                display: 'block',
                width: '100%', // Full width but scaleX will control the animation
                transform: 'scaleX(0)' // Start with underline hidden
            }} /></p></Link>
                        <Link to="/what-we-offer" state={{ re: true }}>  <p className="Footer-content-right-element-column-element">{t('TopBar22')}  <span ref={underlineRef} style={{
                marginTop: '1px',
                height: '1px',
                backgroundColor: 'black',
                display: 'block',
                width: '100%', // Full width but scaleX will control the animation
                transform: 'scaleX(0)' // Start with underline hidden
            }} /></p></Link>
                    </div>
                </div><div className="Footer-content-right-element">
                    <p className="Footer-content-right-element-header">{t('Footer1')}</p>
                    <div className="Footer-content-right-element-column">                  
                        {/*<Link to='/faq'><p className="Footer-content-right-element-column-element">FAQ  <span ref={underlineRef} style={{
                marginTop: '1px',
                height: '1px',
                backgroundColor: 'black',
                display: 'block',
                width: '100%', // Full width but scaleX will control the animation
                transform: 'scaleX(0)' // Start with underline hidden
            }} /></p></Link>*/}
                        <Link to="/financial-report">
                        <p className="Footer-content-right-element-column-element">{t('Footer2')}  <span ref={underlineRef} style={{
                marginTop: '1px',
                height: '1px',
                backgroundColor: 'black',
                display: 'block',
                width: '100%', // Full width but scaleX will control the animation
                transform: 'scaleX(0)' // Start with underline hidden
            }} /></p>
                        </Link>
                    </div>
                </div><div className="Footer-content-right-element">
                    <p className="Footer-content-right-element-header">{t('Footer3')}</p>
                    <div className="Footer-content-right-element-column">
                        <Link to='/contact'>
                        <p className="Footer-content-right-element-column-element">{t('TopBar4')}  <span ref={underlineRef} style={{
                marginTop: '1px',
                height: '1px',
                backgroundColor: 'black',
                display: 'block',
                width: '100%', // Full width but scaleX will control the animation
                transform: 'scaleX(0)' // Start with underline hidden
            }} /></p></Link> 
             <Link to='/terms'>
                        <p className="Footer-content-right-element-column-element">{t('Footer4')}<span ref={underlineRef} style={{
                marginTop: '1px',
                height: '1px',
                backgroundColor: 'black',
                display: 'block',
                width: '100%', // Full width but scaleX will control the animation
                transform: 'scaleX(0)' // Start with underline hidden
            }} /></p></Link>
            <Link to='/privacy'>
                        <p className="Footer-content-right-element-column-element">{t('Footer5')}<span ref={underlineRef} style={{
                marginTop: '1px',
                height: '1px',
                backgroundColor: 'black',
                display: 'block',
                width: '100%', // Full width but scaleX will control the animation
                transform: 'scaleX(0)' // Start with underline hidden
            }} /></p></Link>
                    </div>
                </div>
            </div>
        </div>}
        {deviceWidth<1024 &&
        <>
         <div className="Footer-content-left">
         <Link to='/'>
                <img loading="lazy" decoding="async" alt="Khamsa Insurance and Reinsurance Brokers" src={L} className="Footer-content-left-logo"/></Link>
               {/* <div className="Footer-content-left-logo">
                    <img loading="lazy" decoding="async" alt="" src={LogoLeft} className="Footer-content-left-logo1"/>
                    <img loading="lazy" decoding="async" alt="" src={LogoRight} className="Footer-content-left-logo2"/>
        </div>*/}
                <p className="Footer-content-left-bottom">{t('Address')}</p>
            </div>
            <div className="Footer-content-right">
            <div className="Footer-menu-container">
            <div className="Footer-content-right-element" onClick={toggleExpansion}>
                <p className="Footer-content-right-element-header">{t('TopBar1')}</p>
                <img loading="lazy" decoding="async" alt="" src={isExpanded ? Chevron2 : Chevron} className="Footer-content-right-element-chevron"/>
            </div>
            <div className={`Footer-accordion-content ${isExpanded ? 'expanded' : 'collapsed'}`}>
            <Link to="/who-we-are#aboutUs"> <p className="Footer-content-right-element-column-element">{t('TopBar11')}</p></Link>
            <Link to="/who-we-are#mv"> <p className="Footer-content-right-element-column-element">{t('TopBar12')}</p></Link>
            <Link to="/who-we-are#aze"> <p className="Footer-content-right-element-column-element">{t('TopBar13')}</p></Link>
            </div>
            </div>
            <div className="Footer-menu-container">
            <div className="Footer-content-right-element" onClick={toggleExpansion1}>
                <p className="Footer-content-right-element-header">{t('TopBar2')}</p>
                <img loading="lazy" decoding="async" alt="" src={isExpanded1 ? Chevron2 : Chevron} className="Footer-content-right-element-chevron"/>
            </div>
            <div className={`Footer-accordion-content ${isExpanded1 ? 'expanded' : 'collapsed'}`}>
            <Link to="/what-we-offer" state={{ re: false }}><p className="Footer-content-right-element-column-element">{t('TopBar21')}</p></Link> 
            <Link to="/what-we-offer" state={{ re: true }}><p className="Footer-content-right-element-column-element">{t('TopBar22')}</p></Link> 
            </div>
            </div>
            <div className="Footer-menu-container">
            <div className="Footer-content-right-element" onClick={toggleExpansion2}>
                <p className="Footer-content-right-element-header">{t('Footer1')}</p>
                <img loading="lazy" decoding="async" alt="" src={isExpanded2 ? Chevron2 : Chevron} className="Footer-content-right-element-chevron"/>
            </div>
            <div className={`Footer-accordion-content ${isExpanded2 ? 'expanded' : 'collapsed'}`}>
            {/*<Link to='/faq'> <p className="Footer-content-right-element-column-element">FAQ</p></Link>*/}
                <Link to="/financial-report">
                <p className="Footer-content-right-element-column-element">{t('Footer2')}</p>
                </Link>
            </div>
            </div>
            <div className="Footer-menu-container">
            <div className="Footer-content-right-element" onClick={toggleExpansion3}>
                <p className="Footer-content-right-element-header">{t('Footer3')}</p>
                <img loading="lazy" decoding="async" alt="" src={isExpanded3 ? Chevron2 : Chevron} className="Footer-content-right-element-chevron"/>
            </div>
            <div className={`Footer-accordion-content ${isExpanded3 ? 'expanded' : 'collapsed'}`}>
            <Link to='/contact'><p className="Footer-content-right-element-column-element">{t('TopBar4')}</p></Link>
            <Link to='/terms'><p className="Footer-content-right-element-column-element">{t('Footer4')}</p></Link>
            <Link to='/privacy'><p className="Footer-content-right-element-column-element">{t('Footer5')}</p></Link>
            </div>
            </div>
            </div>           
        </>
        }
        <div className="Footer-line"/>
        <p className="Footer-bottom">{t('Copyright', { year: new Date().getFullYear() })}</p>
    </div>
  )
}

export default Footer